module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-blue-545d3efa.png";